// CAD → USD live rate (Frankfurter API, free, no key, ECB-backed).
// Cached in module scope so we hit the API only once per page load.
import { useEffect, useState } from 'react';

let cachedRate = null;
let inflight = null;

const FALLBACK_RATE = 0.72; // safe fallback if the API is unreachable

export const useCadToUsdRate = () => {
  const [rate, setRate] = useState(cachedRate);

  useEffect(() => {
    if (cachedRate) {
      setRate(cachedRate);
      return;
    }
    if (!inflight) {
      inflight = fetch('https://api.frankfurter.dev/v1/latest?from=CAD&to=USD')
        .then((r) => r.json())
        .then((d) => {
          const r = d?.rates?.USD;
          cachedRate = typeof r === 'number' && r > 0 ? r : FALLBACK_RATE;
          return cachedRate;
        })
        .catch(() => {
          cachedRate = FALLBACK_RATE;
          return cachedRate;
        });
    }
    inflight.then((r) => setRate(r));
  }, []);

  return rate;
};
